.header {
  display: grid;
  font-size: 12px;
  text-align: start;
}

.headerCol {
  font-size: 12px;
  text-align: start;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &::first-letter {
    text-transform: capitalize;
  }
  &.centerHeader {
    justify-content: center;
  }

  &.sortable {
    cursor: pointer;
  }

  .sortArrow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 5px;
    max-width: 22px;
    opacity: 0;
    z-index: -1;
    position: absolute;
    @include themify($themes) {
      color: themed("neutral-secondary");
    }

    svg {
      transform: rotate(180deg);
      transition: transform 0.2s ease-in-out;
    }
    &.active.desc svg {
      transform: rotate(0deg);
    }
  }

  &:hover .sortArrow,
  .sortArrow.active {
    opacity: 1;
    z-index: unset;
    position: relative;
    @include themify($themes) {
      color: themed("main-primary");
    }
  }
}

.tableHeader {
  height: 41px;
  font-size: 12px;
  padding: 12px 24px;
  @include themify($themes) {
    border-bottom: solid 1px themed("neutral-secondary");
    color: themed("neutral-primary");
  }

  &.tableIsOverflown {
    padding-right: 32px;
  }
}
